module.exports = __webpack_public_path__ + "site/img/fben.c7c22fbe.png";